import React, { Component } from "react";
import CatalogoCobroTabla from "./CatalogoCobroTabla";
import { connect } from "react-redux";
import { getCatalogoCobroList } from './CatalogoCobroAction'
import { withRouter } from 'react-router-dom';

class CatologoCobroContainer extends Component {

    componentDidMount() {
        //console.log("CatologoCobroContainer");
        this.props.dispatch(getCatalogoCobroList());
    }

    render() {
        return (
            <div>
                <CatalogoCobroTabla />
            </div>
        );
    }
}

export default connect()(CatologoCobroContainer);
